import {
  entityListTimeSeparatorClass,
  entityListTimeSeparatorLabelClass,
  entityListTimeSeparatorLineClass,
} from './entityListClasses.js';

/**
 * Time Separator between Entity List cards (Figma node 6064:10045): a label with a trailing line,
 * used to group cards under date headings ("Today", "A month ago").
 *
 * @param {object} props
 * @param {string} [props.label] - Heading text. A missing or empty label renders nothing.
 * @param {string} [props.className] - Extra classes appended to the separator root.
 */
const EntityListTimeSeparator = ({ label, className = '', ...props }) => {
  if (label == null || label === '') return null;

  return (
    <div
      className={[entityListTimeSeparatorClass, className].filter(Boolean).join(' ')}
      role="separator"
      aria-label={label}
      {...props}
    >
      <span className={entityListTimeSeparatorLabelClass}>{label}</span>
      <span className={entityListTimeSeparatorLineClass} aria-hidden />
    </div>
  );
};

export default EntityListTimeSeparator;
